import type { DesktopBridge } from '@novachat/shared';

/**
 * The desktop app's bridge (Electron preload); undefined in a browser. Older desktop builds may
 * lack newer methods, so check a method exists before calling it.
 */
export const desktop: DesktopBridge | undefined = (window as Window & { novachat?: DesktopBridge }).novachat;
